import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { coreLocalStorage } from '@/core/utils/localStorage';
import { getApiUrl } from '@/shared/helpers/environmentHelper';
export const authApi = createApi({
    reducerPath: 'api/auth',
    // Our `baseApiQuery` doesn't work for some reason. There is very non-descriptive error in console before app is even started.
    // baseQuery: baseApiQuery,
    baseQuery: fetchBaseQuery({
        baseUrl: `${getApiUrl()}/api/`,
        prepareHeaders: (headers) => {
            const token = coreLocalStorage.getItem('token');
            if (token)
                headers.set('authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getCurrentUser: builder.query({
            query: () => 'userinfo',
            transformResponse: (response) => {
                // const token = coreLocalStorage.getItem('token');
                // // TODO: to delete
                // console.log('token in getCurrentUser(): ', token);
                // const { expiration, userId } = decodeToken(token ?? '');
                // tODO: CREATE user
                return {
                    // expiration,
                    userId: response.userId,
                    userFullName: response.userFullName,
                    userEmail: response.userEmail,
                    avatar: response.thumbnail,
                    roles: response.roles,
                    claims: response.claims,
                    crossDockIds: response.crossDockIds,
                    locationIds: response.locationIds,
                };
            },
        }),
    }),
});
export const { useGetCurrentUserQuery } = authApi;
